import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import EmailValidationDashboard from "pages/email-validation-dashboard";
import ApiDocumentation from "pages/api-documentation";
import ValidationHistory from "pages/validation-history";
import AccountSettings from "pages/account-settings";
import NotFound from "pages/NotFound";
import LandingPage from "pages/landing-page";
import PricingPage from "pages/pricing";

// Auth imports
import Login from "pages/auth/Login";
import Register from "pages/auth/Register";
// Admin imports
import AdminDashboard from "pages/admin-dashboard";
// Client imports
import ClientOnboarding from "pages/client-onboarding";
// Legal pages
import Terms from "pages/terms";
import Privacy from "pages/privacy";
import CancellationRefundPolicy from "pages/cancellation-refund";
import ShippingDeliveryPolicy from "pages/shipping-delivery";
import ContactPage from "pages/contact";
import AboutPage from "pages/about";
import PaymentReturn from "pages/payment-return";
import BlogListing from "pages/blog-listing";



const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<EmailValidationDashboard />} />
        <Route path="/landingpage" element={<LandingPage />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/docs" element={<ApiDocumentation />} />
        <Route path="/api-documentation" element={<ApiDocumentation />} />
        <Route path="/validation-history" element={<ValidationHistory />} />
        <Route path="/bulk-email-validation" element={<Navigate to="/" replace />} />
        <Route path="/account-settings" element={<AccountSettings />} />
        <Route path="/pricing" element={<PricingPage />} />

        
        {/* Auth routes */}
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/register" element={<Register />} />
        
        {/* Admin routes */}
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        
        {/* Client routes */}
        <Route path="/client-onboarding" element={<ClientOnboarding />} />
        
        {/* Legal routes */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cancellation-refund" element={<CancellationRefundPolicy />} />
        <Route path="/shipping-delivery" element={<ShippingDeliveryPolicy />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contactus" element={<ContactPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/refund-policy" element={<CancellationRefundPolicy />} />
        <Route path="/about" element={<AboutPage />} />

        <Route path="/payment-return" element={<PaymentReturn />} />

        {/* Blog routes */}
        <Route path="/blog" element={<BlogListing />} />
        <Route path="/blog/:slug" element={<BlogListing />} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;